const META = {
  "/": ["SømSignature – Skredder i Bergen | Tilpasning, bunad og brudekjoler", "Skredderatelier i Bergen. Tilpasning og reparasjon av klær, bunad, brudekjoler, skreddersøm og sykurs. Gratis prøvetime – bestill i dag."],
  "/tjenester": ["Skreddertjenester og klesreparasjon i Bergen | SømSignature", "Legge opp bukser, bytte glidelås, sy inn jakker og kjoler, bunadstilpasning og skreddersøm etter mål i Bergen."],
  "/bunad": ["Bunadstilpasning i Bergen – sy inn, slippe ut og arvet bunad | SømSignature", "Tilpasning og justering av bunad i Bergen: nye, arvede og herrebunader. Gratis bunadskonsultasjon før 17. mai og konfirmasjon."],
  "/brudekjoler": ["Brudekjole og festantrekk i Bergen – skreddersydd | SømSignature", "Få brudekjolen skreddersydd eller sy din egen med veiledning. Tilpasning av brudekjoler og festantrekk i Bergen."],
  "/sykurs": ["Sykurs i Bergen – individuell syundervisning | SømSignature", "Personlige sykurs for nybegynnere og viderekomne i Bergen. Lær å sy med veiledning fra skredder Liisa Lipasina."],
  "/priser": ["Priser skredder Bergen høsten 2026 | SømSignature", "Prisliste for tilpasning og reparasjon av bukser, jakker, kjoler, bunad og brudekjoler i Bergen. Veiledende priser."],
  "/handbok": ["Reparer klærne dine selv – illustrert håndbok | SømSignature", "Digital håndbok i klesreparasjon steg for steg, fra skredder Liisa Lipasina."],
  "/bestill": ["Bestill tid hos skredder i Bergen | SømSignature", "Bestill gratis prøvetime eller be om pristilbud på tilpasning, bunad, brudekjole eller sykurs."],
  "/om-liisa": ["Om skredder Liisa Lipasina | SømSignature Bergen", "Møt Liisa – skredder i Bergen med lidenskap for håndverk, tilpasning og unike plagg."],
  "/galleri": ["Galleri – arbeider fra atelieret | SømSignature Bergen", "Se eksempler på tilpasning, festantrekk og brudekjoler fra SømSignature i Bergen."],
  "/kontakt": ["Kontakt skredder i Bergen – Birkeveien 2 | SømSignature", "Besøk atelieret i Birkeveien 2, 5093 Bergen. Åpent mandag–fredag 10–17. Telefon 90402421."],
};

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", value);
};

export const applyMeta = (path) => {
  const [title, desc] = META[path] || META["/"];
  document.title = title;
  setMeta("name", "description", desc);
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", desc);
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
  link.href = `${window.location.origin}${path}`;
};

export const setJsonLd = (id, data) => {
  let el = document.getElementById(id);
  if (!el) { el = document.createElement("script"); el.type = "application/ld+json"; el.id = id; document.head.appendChild(el); }
  el.textContent = JSON.stringify(data);
};
